"use client";

import { useEffect } from "react";
import { CALENDAR_URL, GOOGLE_CALENDAR_URL } from "@/utils/consts";

export const CalendarRedirect = () => {
  useEffect(() => {
    const openCalendar = (event: MouseEvent) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const link = target.closest<HTMLAnchorElement>(`a[href="${CALENDAR_URL}"]`);
      if (link) {
        window.open(GOOGLE_CALENDAR_URL, "_blank", "noopener,noreferrer");
      }
    };

    document.addEventListener("click", openCalendar);
    return () => document.removeEventListener("click", openCalendar);
  }, []);

  return null;
};
